import { render, staticRenderFns } from "./SliderNav.vue?vue&type=template&id=eb5d7dfe&scoped=true&"
import script from "./SliderNav.vue?vue&type=script&lang=js&"
export * from "./SliderNav.vue?vue&type=script&lang=js&"
import style0 from "./SliderNav.vue?vue&type=style&index=0&id=eb5d7dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5d7dfe",
  null
  
)

export default component.exports